import React from 'react';
import Modal from 'react-modal';
import { strings } from '../../localization';

const ConfirmDialog = ({ isOpen, title, message, children, contentLabel, onOk, onCancel, onDismiss }) => (
    <Modal
        isOpen={isOpen}
        contentLabel={contentLabel}
        className="react-modal-content react-modal-sm"
        overlayClassName="react-modal-overlay"
        onRequestClose={onDismiss}
    >
        <div className="container-fluid form-card">
            {children ? children : <React.Fragment><h1>{title}</h1><p>{message}</p></React.Fragment>}
            <div className="row">
                <div className="col-12 action-btns text-right">
                    <button className="btn btn-outline-blue" onClick={onCancel}>
                        <i className="material-icons">cancel</i>
                        {strings.formatString(strings.app_cancel)}
                    </button>
                    <button className="btn" onClick={onOk}>
                        <i className="material-icons">check</i>
                        {strings.formatString(strings.app_ok)}
                    </button>
                </div>
            </div>
        </div>
    </Modal>
);

export default ConfirmDialog;
